// extracted by mini-css-extract-plugin
export default {"planContainer":"Plan_planContainer__PYoCV","planPrice":"Plan_planPrice__wk1Er","type":"Plan_type__3Cf-r","line":"Plan_line__dZh1D","planOptions":"Plan_planOptions__fbScZ"};